import { SakaiRubricGradingComment } from "./src/SakaiRubricGradingComment.js";

customElements.define("sakai-rubric-grading-comment", SakaiRubricGradingComment);
